"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const token_type_1 = require("./token-type");
exports.PLUS = new token_type_1.TokenType("+");
exports.MINUS = new token_type_1.TokenType("−"); // minus, not hyphen-minus
exports.TIMES = new token_type_1.TokenType("×");
exports.DIVIDE = new token_type_1.TokenType("÷");
exports.SQRT = new token_type_1.TokenType("√");
exports.LPAREN = new token_type_1.TokenType("(");
exports.RPAREN = new token_type_1.TokenType(")");
exports.POWER = new token_type_1.TokenType("^");
exports.COMMA = new token_type_1.TokenType(",");
exports.NumericLiteral = new token_type_1.TokenType("NumericLiteral", /^([0-9]*\.[0-9]*(E[+−]?[0-9]*)?|[0-9]+(E[+−]?[0-9]*)?)/);
exports.Alphanumeric = new token_type_1.TokenType("Alphanumeric", /^([A-Za-z][A-Za-z0-9]+|π)/);
/**
 * Placeholder token type for the end of the string.
 */
exports.END = new token_type_1.TokenType("END");
/**
 * Sentinel token type.
 */
const NONE = new token_type_1.TokenType("NONE");
exports.tokenTypes = [
    exports.PLUS,
    exports.MINUS,
    exports.TIMES,
    exports.DIVIDE,
    exports.SQRT,
    exports.LPAREN,
    exports.RPAREN,
    exports.POWER,
    exports.COMMA,
    exports.NumericLiteral,
    exports.Alphanumeric
];
class Lexer {
    constructor() {
        this.lastTokenType = NONE;
        this.input = "";
    }
    reset() {
        this.lastTokenType = NONE;
        this.input = "";
    }
    /**
     * Lexes the input string into a stream of tokens.
     */
    *lex() {
        outerWhile: while (this.input.length !== 0) {
            for (let tokenType of exports.tokenTypes) {
                const { pattern } = tokenType;
                if (typeof pattern === "string") {
                    // Match exactly `pattern` string.
                    if (this.input.startsWith(pattern)) {
                        yield { type: tokenType, value: pattern };
                        this.input = this.input.substring(pattern.length);
                        continue outerWhile;
                    }
                }
                else {
                    // Match the string with `pattern` regex.
                    const regexResult = pattern.exec(this.input);
                    if (regexResult != null) {
                        yield {
                            type: tokenType,
                            value: this.input.substring(0, regexResult[0].length)
                        };
                        this.input = this.input.substring(regexResult[0].length);
                        continue outerWhile;
                    }
                }
            }
            throw new Error(`Unable to lex string: ${this.input}`);
        }
    }
}
exports.Lexer = Lexer;
const staticLexer = new Lexer();
function lex(input) {
    staticLexer.reset();
    staticLexer.input = input;
    return [...staticLexer.lex()];
}
exports.lex = lex;
//# sourceMappingURL=lexer.js.map